<template>
    <div style="min-width: 400px; max-width: 600px; position: relative">
        <template v-if="loading">
            <div class="fill-height d-flex align-center justify-center">
                <app-centre-loader label="Loading Activity Distribution"></app-centre-loader>
            </div>
        </template>
        <template v-else>
            <div
                    class="text-center text-h6 font-weight-thin"
            >
                Activity Distribution Today
            </div>
            <div style="position: relative;">
                <div class="d-flex flex-column justify-space-between" style="position: absolute; width: 50%; height: 21%; top: 8%">
                    <div class="d-flex align-center body-2 justify-end pr-3" style="line-height: 1">
                        Idle
                        <v-icon color="orange" class="px-1" small>mdi-timer-sand-full</v-icon>
                        {{ !stats ? '00:00' : hourDisplay(stats.it) }}
                    </div>

                    <div class="d-flex align-center body-2 justify-end pr-3" style="line-height: 1">
                        {{ !stats ? '00:00' : labelsRef[1].text }}
                        <v-icon :color="labelsRef[1].color" class="px-1" small>{{ labelsRef[1].icon }}</v-icon>
                        {{ !stats ? '00:00' : hourDisplay(stats.pt) }}
                    </div>

                    <div class="d-flex align-center body-2 justify-end pr-3" style="line-height: 1">
                        {{ labelsRef[0].text }}
                        <v-icon :color="labelsRef[0].color" class="px-1" small>{{ labelsRef[0].icon }}</v-icon>
                        {{ !stats ? '00:00' : hourDisplay(stats.nt) }}
                    </div>

                    <div class="d-flex align-center body-2 justify-end pr-3" style="line-height: 1">
                        {{ labelsRef[2].text }}
                        <v-icon :color="labelsRef[2].color" class="px-1" small>{{ labelsRef[2].icon }}</v-icon>
                        {{ !stats ? '00:00' : hourDisplay(stats.ut) }}
                    </div>
                </div>
                <apex-chart type="radialBar" :options="chartOptions" :series="!stats ? [1,1,1,1] : series"></apex-chart>
            </div>
        </template>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {durationDisplay, hourDisplay, hourDisplayWithoutUnit} from "@/core/codeFunctions";
import AppIcon from "@/components/Shared/AppIcon";
import {mapActions, mapGetters} from "vuex";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
export default {
    components: {
        AppCentreLoader,
        AppIcon,
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: [],
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit,
            hourDisplay,
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        ...mapActions(['gotoAppStats']),
        async loadProductivity() {
            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/activityDistribution')
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        ...mapGetters(['labelsRef']),
        labels() {return this.stats.map(stat => stat.key)},
        series() {

            let maxVal = [this.stats.nt, this.stats.it, this.stats.pt, this.stats.ut]
                    .reduce((max, val) => {
                        return val > max ? val : max
                    }, 0)

            return [
                Math.round(this.stats.ut / maxVal * 100),
                Math.round(this.stats.nt / maxVal * 100),
                Math.round(this.stats.pt / maxVal * 100),
                Math.round(this.stats.it / maxVal * 100),
            ]
        },

        chartOptions() {
            const colors = [
                `var(--v-${this.labelsRef[2].color}-darken2)`,
                `var(--v-${this.labelsRef[0].color}-darken2)`,
                `var(--v-${this.labelsRef[1].color}-darken2)`,
                `var(--v-orange-darken2)`,
            ];

            return {
                colors: colors,
                labels: [
                    this.labelsRef[0].text,
                    'Idle',
                    this.labelsRef[1].text,
                    this.labelsRef[2].text,
                ],

                plotOptions: {
                    height: 300,
                    fill: {
                        type: 'gradient',
                        colors: colors
                    },
                    radialBar: {
                        inverseOrder: true,
                        startAngle: 0,
                        endAngle: 270,
                        track: {
                            opacity: 1,
                            show: false,
                            margin: 10,
                        },
                        hollow: {
                            margin: 0,
                            size: '40%',
                        },
                        dataLabels: {
                            enabled: false,
                            name: {show: false},
                            value: {show: false},
                        }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: "horizontal",
                        shadeIntensity: 0.5,
                        gradientToColors: [
                            `var(--v-${this.labelsRef[2].color}-lighten1)`,
                            `var(--v-${this.labelsRef[0].color}-lighten1)`,
                            `var(--v-${this.labelsRef[1].color}-lighten1)`,
                            `var(--v-orange-lighten1)`,
                        ],
                        inverseColors: true,
                        stops: [0]
                    },
                },
                legend: {
                    show: true,
                    floating: true,
                    fontSize: '16px',
                    position: 'left',

                    offsetX: '50',
                    offsetY: '50%',
                    labels: {
                        useSeriesColors: true,
                    },
                    markers: {
                        size: 0
                    },
                    formatter: function(seriesName, opts) {
                        return seriesName// + ":  " + opts.w.globals.series[opts.seriesIndex]
                    },
                    itemMargin: {
                        vertical: 3
                    }
                },
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    show: false,
                    curve: 'smooth',
                    lineCap: 'round',
                    colors: undefined,
                    width: 2,
                    dashArray: 0,
                },
                tooltip: {
                    enabled: false
                }
            }
        },
    }
}
</script>

<style scoped>

.txt:hover {
    text-decoration: underline;
    color: #fff !important;
    cursor: pointer;
}

</style>